import { render, staticRenderFns } from "./ResizableSidebarLayout.vue?vue&type=template&id=5003e24e&scoped=true&"
import script from "./ResizableSidebarLayout.vue?vue&type=script&lang=ts&"
export * from "./ResizableSidebarLayout.vue?vue&type=script&lang=ts&"
import style0 from "./ResizableSidebarLayout.vue?vue&type=style&index=0&id=5003e24e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5003e24e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VNavigationDrawer } from 'vuetify/lib/components/VNavigationDrawer';
installComponents(component, {VBtn,VIcon,VNavigationDrawer})
